export enum PrintType {
    RECEIPT = "RECEIPT",
    ORDER_CHECK = "ORDER_CHECK",
    SLING = "SLING",
    SAILOR_FILES = "SAILOR_FILES",
    CUSTOMER_FILES = "CUSTOMER_FILES",
}